import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES
} from 'shared/constants';

const propsSchema = [
  {
    key: 'theme',
    label: 'Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'links',
        label: 'Links',
        type: types.ARRAY,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
        ]
      }
    ]
  },
];

const defaultProps = {
  theme: 'LIGHT',
  title: 'DOWNLOAD PICTURES, VIDEOS, AND MORE HERE.',
  sections: [
    {
      title: 'Facilities',
      links: [{
        label: 'Photos',
        url: ''
      }]
    },
    {
      title: 'Leadership',
      links: [{
        label: 'Photos',
        url: ''
      }]
    },
    {
      title: 'Product',
      links: [{
        label: 'Photos',
        url: ''
      }, {
        label: 'FF91 Press Information',
        url: ''
      }]
    },
    {
      title: 'More',
      links: [{
        label: 'Video',
        url: ''
      }, {
        label: 'FF Logo',
        url: ''
      }]
    },
  ],
};

export default {
  title: 'Media Download',
  id: 'MediaDownload',
  propsSchema,
  defaultProps
};
